import classNames from 'classnames';
import React, {useState} from 'react';
import CalenderWrapperBottomSheet from '../../../../../UpgradePrmotionCardToCard/CalenderWrapperBottomSheet';
import moment from 'jalali-moment';
import {FormikErrors, FormikTouched} from 'formik';

interface IDateBottomsheetProps {
  name: string;
  placeholder?: string;
  onChange: (e: string) => void;
  value?: string;
  data: Array<{guid: string; title: string}>;
  errors?: FormikErrors<
    Record<
      string,
      string | number | Record<string, string | number | undefined> | undefined
    >
  >;
  touched?: FormikTouched<
    Record<
      string,
      string | number | Record<string, string | number | undefined> | undefined
    >
  >;
  generalTitle?: string;
  generalDesc?: string;
  title?: string;
  titleRequired?: boolean;
}

const DateBottomSheet = ({
  name,
  placeholder,
  onChange,
  value,
  errors,
  touched,
  generalTitle,
  generalDesc,
  titleRequired = true,
  title = 'تاریخ واریز',
}: IDateBottomsheetProps) => {
  const [isOpenBottomSheet, setIsOpenBottomSheet] = useState<boolean>(false);

  return (
    <>
      <div className="w-full flex flex-col">
        <span className="text-gray-900 text-md font-[500]">{generalTitle}</span>
        {generalDesc && (
          <span className="text-gray-900 text-md my-3">{generalDesc}</span>
        )}
        <button
          className={classNames(
            'w-full flex h-[50px] rounded-[8px] border-[1px] border-gray-700 items-center gap-2 px-2 justify-between ',
            {
              '!border-green-600':
                touched && errors && !errors[name] && !touched[name] && value,
              '!border-red-500':
                errors && touched && errors[name] && touched[name],
              '!border-gray-400':
                touched && errors && !errors[name] && !touched[name] && !value,
            },
          )}
          type="button"
          onClick={() => setIsOpenBottomSheet(true)}
        >
          <p className="p-0 m-0 h-full flex items-center text-md">
            {value ? (
              <>{moment(value).format('YYYY/MM/DD')}</>
            ) : (
              <>
                {title}{' '}
                {titleRequired === true && (
                  <span className="text-red-700">*</span>
                )}
              </>
            )}
          </p>
          <i className="icon-nameArrow---Down-2-1" />
        </button>
        {touched && errors && errors[name] && touched[name] && (
          <p className="text-red-500 text-xs font-Regular pb-0 mb-0 pt-2">
            {errors[name]}
          </p>
        )}
      </div>
      <CalenderWrapperBottomSheet
        addDateHandler={(timeValue: string) => {
          onChange(timeValue);
        }}
        isOpenBottomSheet={isOpenBottomSheet}
        setIsOpenBottomSheet={setIsOpenBottomSheet}
      />
    </>
  );
};

export default DateBottomSheet;
